import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CombinacionSkumasterService extends ApiService {
    entityType = EntityType.ATRIBUTO_SKUMASTER;
    url = 'api/combinaciones-skumaster/';
}
